export default __webpack_public_path__ + "static/media/ihr-klare-seraphim.ec6630b2.webp";